

export class Constants {


    public static USER: string = 'webteamu444';
    public static nooorFolderId: string = 'NooorMainFolder';
    public static nooorMediaFolderId: string = 'NooorMainMediaFolder';
    // public static syncUrl = '@sync.semanoor.com';
    // public static lcsUrl = 'liquidgql.semanoor.com';
    // public static nasUrl = 'admingql.semanoor.com';
    public static syncUrl = '@sync-dev.semanooor.com';
    public static lcsUrl = 'lcsgql-dev.semanooor.com';
    public static nasUrl = 'nasgql-dev.semanooor.com';
    public static TEMPLATES = {};
    public static Electron_TEMPLATES = {};
    public static TEMPLATES_Arr: any = [       
        {
            "name": "Theme 1",
            "translateName": "Theme",
            "ID": 3,
            "back_P": "http://hyd.semanoor.com/NooorM/Templates/3/back_P.png",
            "backThumb": "http://hyd.semanoor.com/NooorM/Templates/3/backThumb.png",
            "card": "http://hyd.semanoor.com/NooorM/Templates/3/card.png",
            "front_P": "http://hyd.semanoor.com/NooorM/Templates/3/front_P.png",
            "frontThumb": "http://hyd.semanoor.com/NooorM/Templates/3/frontThumb.png",
            "page_P": "http://hyd.semanoor.com/NooorM/Templates/3/page_P.png",
            "pageThumb": "http://hyd.semanoor.com/NooorM/Templates/3/pageThumb.png"
        },
        {
            "name": "Theme 2",
            "translateName": "Theme",
            "ID": 4,
            "back_P": "http://hyd.semanoor.com/NooorM/Templates/4/back_P.png",
            "backThumb": "http://hyd.semanoor.com/NooorM/Templates/4/backThumb.png",
            "card": "http://hyd.semanoor.com/NooorM/Templates/4/card.png",
            "front_P": "http://hyd.semanoor.com/NooorM/Templates/4/front_P.png",
            "frontThumb": "http://hyd.semanoor.com/NooorM/Templates/4/frontThumb.png",
            "page_P": "http://hyd.semanoor.com/NooorM/Templates/4/page_P.png",
            "pageThumb": "http://hyd.semanoor.com/NooorM/Templates/4/pageThumb.png"
        },
        {
            "name": "Theme 3",
            "translateName": "Theme",
            "ID": 5,
            "back_P": "http://hyd.semanoor.com/NooorM/Templates/5/back_P.png",
            "backThumb": "http://hyd.semanoor.com/NooorM/Templates/5/backThumb.png",
            "card": "http://hyd.semanoor.com/NooorM/Templates/5/card.png",
            "front_P": "http://hyd.semanoor.com/NooorM/Templates/5/front_P.png",
            "frontThumb": "http://hyd.semanoor.com/NooorM/Templates/5/frontThumb.png",
            "page_P": "http://hyd.semanoor.com/NooorM/Templates/5/page_P.png",
            "pageThumb": "http://hyd.semanoor.com/NooorM/Templates/5/pageThumb.png"
        },
        {
            "name": "Theme 4",
            "translateName": "Theme",
            "ID": 6,
            "back_P": "http://hyd.semanoor.com/NooorM/Templates/6/back_P.png",
            "backThumb": "http://hyd.semanoor.com/NooorM/Templates/6/backThumb.png",
            "card": "http://hyd.semanoor.com/NooorM/Templates/6/card.png",
            "front_P": "http://hyd.semanoor.com/NooorM/Templates/6/front_P.png",
            "frontThumb": "http://hyd.semanoor.com/NooorM/Templates/6/frontThumb.png",
            "page_P": "http://hyd.semanoor.com/NooorM/Templates/6/page_P.png",
            "pageThumb": "http://hyd.semanoor.com/NooorM/Templates/6/pageThumb.png"
        },
        {
            "name": "Theme 5",
            "translateName": "Theme",
            "ID": 7,
            "back_P": "http://hyd.semanoor.com/NooorM/Templates/7/back_P.png",
            "backThumb": "http://hyd.semanoor.com/NooorM/Templates/7/backThumb.png",
            "card": "http://hyd.semanoor.com/NooorM/Templates/7/card.png",
            "front_P": "http://hyd.semanoor.com/NooorM/Templates/7/front_P.png",
            "frontThumb": "http://hyd.semanoor.com/NooorM/Templates/7/frontThumb.png",
            "page_P": "http://hyd.semanoor.com/NooorM/Templates/7/page_P.png",
            "pageThumb": "http://hyd.semanoor.com/NooorM/Templates/7/pageThumb.png"
        },
        {
            "name": "Theme 6",
            "translateName": "Theme",
            "ID": 8,
            "back_P": "http://hyd.semanoor.com/NooorM/Templates/8/back_P.png",
            "backThumb": "http://hyd.semanoor.com/NooorM/Templates/8/backThumb.png",
            "card": "http://hyd.semanoor.com/NooorM/Templates/8/card.png",
            "front_P": "http://hyd.semanoor.com/NooorM/Templates/8/front_P.png",
            "frontThumb": "http://hyd.semanoor.com/NooorM/Templates/8/frontThumb.png",
            "page_P": "http://hyd.semanoor.com/NooorM/Templates/8/page_P.png",
            "pageThumb": "http://hyd.semanoor.com/NooorM/Templates/8/pageThumb.png"
        },
        {
            "name": "Theme 7",
            "translateName": "Theme",
            "ID": 9,
            "back_P": "http://hyd.semanoor.com/NooorM/Templates/9/back_P.png",
            "backThumb": "http://hyd.semanoor.com/NooorM/Templates/9/backThumb.png",
            "card": "http://hyd.semanoor.com/NooorM/Templates/9/card.png",
            "front_P": "http://hyd.semanoor.com/NooorM/Templates/9/front_P.png",
            "frontThumb": "http://hyd.semanoor.com/NooorM/Templates/9/frontThumb.png",
            "page_P": "http://hyd.semanoor.com/NooorM/Templates/9/page_P.png",
            "pageThumb": "http://hyd.semanoor.com/NooorM/Templates/9/pageThumb.png"
        },
        {
            "name": "Theme 8",
            "translateName": "Theme",
            "ID": 10,
            "back_P": "http://hyd.semanoor.com/NooorM/Templates/10/back_P.png",
            "backThumb": "http://hyd.semanoor.com/NooorM/Templates/10/backThumb.png",
            "card": "http://hyd.semanoor.com/NooorM/Templates/10/card.png",
            "front_P": "http://hyd.semanoor.com/NooorM/Templates/10/front_P.png",
            "frontThumb": "http://hyd.semanoor.com/NooorM/Templates/10/frontThumb.png",
            "page_P": "http://hyd.semanoor.com/NooorM/Templates/10/page_P.png",
            "pageThumb": "http://hyd.semanoor.com/NooorM/Templates/10/pageThumb.png"
        },
        {
            "name": "Theme 9",
            "translateName": "Theme",
            "ID": 11,
            "back_P": "http://hyd.semanoor.com/NooorM/Templates/11/back_P.png",
            "backThumb": "http://hyd.semanoor.com/NooorM/Templates/11/backThumb.png",
            "card": "http://hyd.semanoor.com/NooorM/Templates/11/card.png",
            "front_P": "http://hyd.semanoor.com/NooorM/Templates/11/front_P.png",
            "frontThumb": "http://hyd.semanoor.com/NooorM/Templates/11/frontThumb.png",
            "page_P": "http://hyd.semanoor.com/NooorM/Templates/11/page_P.png",
            "pageThumb": "http://hyd.semanoor.com/NooorM/Templates/11/pageThumb.png"
        },       
        {
            "name": "Theme 10",
            "translateName": "Theme",
            "ID": 15,
            "back_P": "http://hyd.semanoor.com/NooorM/Templates/15/back_P.png",
            "backThumb": "http://hyd.semanoor.com/NooorM/Templates/15/backThumb.png",
            "card": "http://hyd.semanoor.com/NooorM/Templates/15/card.png",
            "front_P": "http://hyd.semanoor.com/NooorM/Templates/15/front_P.png",
            "frontThumb": "http://hyd.semanoor.com/NooorM/Templates/15/frontThumb.png",
            "page_P": "http://hyd.semanoor.com/NooorM/Templates/15/page_P.png",
            "pageThumb": "http://hyd.semanoor.com/NooorM/Templates/15/pageThumb.png"
        }];
    public static Electron_TEMPLATES_Arr: any = [
        {
            "name": "Theme 1",
            "translateName": "Theme",
            "ID": 1,
            "back_P": "../../assets/Templates/1/back_P.png",
            "backThumb": "assets/Templates/1/backThumb.png",
            "card": "assets/Templates/1/card.png",
            "front_P": "../../assets/Templates/1/front_P.png",
            "frontThumb": "assets/Templates/1/frontThumb.png",
            "page_P": "../../assets/Templates/1/page_P.png",
            "pageThumb": "assets/Templates/1/pageThumb.png"
        },
        {
            "name": "Theme 2",
            "translateName": "Theme",
            "ID": 2,
            "back_P": "../../assets/Templates/2/back_P.png",
            "backThumb": "assets/Templates/2/backThumb.png",
            "card": "assets/Templates/2/card.png",
            "front_P": "../../assets/Templates/2/front_P.png",
            "frontThumb": "assets/Templates/2/frontThumb.png",
            "page_P": "../../assets/Templates/2/page_P.png",
            "pageThumb": "assets/Templates/2/pageThumb.png"
        },
        {
            "name": "Theme 3",
            "translateName": "Theme",
            "ID": 3,
            "back_P": "../../assets/Templates/3/back_P.png",
            "backThumb": "assets/Templates/3/backThumb.png",
            "card": "assets/Templates/3/card.png",
            "front_P": "../../assets/Templates/3/front_P.png",
            "frontThumb": "assets/Templates/3/frontThumb.png",
            "page_P": "../../assets/Templates/3/page_P.png",
            "pageThumb": "assets/Templates/3/pageThumb.png"
        },
        {
            "name": "Theme 4",
            "translateName": "Theme",
            "ID": 4,
            "back_P": "../../assets/Templates/4/back_P.png",
            "backThumb": "assets/Templates/4/backThumb.png",
            "card": "assets/Templates/4/card.png",
            "front_P": "../../assets/Templates/4/front_P.png",
            "frontThumb": "assets/Templates/4/frontThumb.png",
            "page_P": "../../assets/Templates/4/page_P.png",
            "pageThumb": "assets/Templates/4/pageThumb.png"
        },
        {
            "name": "Theme 5",
            "translateName": "Theme",
            "ID": 5,
            "back_P": "../../assets/Templates/5/back_P.png",
            "backThumb": "assets/Templates/5/backThumb.png",
            "card": "assets/Templates/5/card.png",
            "front_P": "../../assets/Templates/5/front_P.png",
            "frontThumb": "assets/Templates/5/frontThumb.png",
            "page_P": "../../assets/Templates/5/page_P.png",
            "pageThumb": "assets/Templates/5/pageThumb.png"
        },
        {
            "name": "Theme 6",
            "translateName": "Theme",
            "ID": 6,
            "back_P": "../../assets/Templates/6/back_P.png",
            "backThumb": "assets/Templates/6/backThumb.png",
            "card": "assets/Templates/6/card.png",
            "front_P": "../../assets/Templates/6/front_P.png",
            "frontThumb": "assets/Templates/6/frontThumb.png",
            "page_P": "../../assets/Templates/6/page_P.png",
            "pageThumb": "assets/Templates/6/pageThumb.png"
        },
        {
            "name": "Theme 7",
            "translateName": "Theme",
            "ID": 7,
            "back_P": "../../assets/Templates/7/back_P.png",
            "backThumb": "assets/Templates/7/backThumb.png",
            "card": "assets/Templates/7/card.png",
            "front_P": "../../assets/Templates/7/front_P.png",
            "frontThumb": "assets/Templates/7/frontThumb.png",
            "page_P": "../../assets/Templates/7/page_P.png",
            "pageThumb": "assets/Templates/7/pageThumb.png"
        },
        {
            "name": "Theme 8",
            "translateName": "Theme",
            "ID": 8,
            "back_P": "../../assets/Templates/8/back_P.png",
            "backThumb": "assets/Templates/8/backThumb.png",
            "card": "assets/Templates/8/card.png",
            "front_P": "../../assets/Templates/8/front_P.png",
            "frontThumb": "assets/Templates/8/frontThumb.png",
            "page_P": "../../assets/Templates/8/page_P.png",
            "pageThumb": "assets/Templates/8/pageThumb.png"
        },
        {
            "name": "Theme 9",
            "translateName": "Theme",
            "ID": 9,
            "back_P": "../../assets/Templates/9/back_P.png",
            "backThumb": "assets/Templates/9/backThumb.png",
            "card": "assets/Templates/9/card.png",
            "front_P": "../../assets/Templates/9/front_P.png",
            "frontThumb": "assets/Templates/9/frontThumb.png",
            "page_P": "../../assets/Templates/9/page_P.png",
            "pageThumb": "assets/Templates/9/pageThumb.png"
        },
        {
            "name": "Theme 10",
            "translateName": "Theme",
            "ID": 10,
            "back_P": "../../assets/Templates/10/back_P.png",
            "backThumb": "assets/Templates/10/backThumb.png",
            "card": "assets/Templates/10/card.png",
            "front_P": "../../assets/Templates/10/front_P.png",
            "frontThumb": "assets/Templates/10/frontThumb.png",
            "page_P": "../../assets/Templates/10/page_P.png",
            "pageThumb": "assets/Templates/10/pageThumb.png"
        }];




    public static ENRICHMENTOPIONS = {};
    public static ENRICHMENTOPIONS_arr = [{
        "id": 1,
        "icon": "icon-Blank-page",
        "text": "Blank",
        "color": "#4CAF50",
        "type": "blankPage",
        "isService": false
    },
    {
        "id": 2,
        "icon": "icon-Internet-search",
        "text": "Internet search",
        "color": "#FF5722",
        "type": "internet",
        "isService": false
    },
    {
        "id": 3,
        "icon": "icon-Page-from-book",
        "text": "Page from book",
        "color": "#795548",
        "type": "pageFromBook",
        "isService": false
    },
    {
        "id": 4,
        "icon": "icon-Duplicate-as-Image",
        "text": "Duplicate as image",
        "color": "#9C27B0",
        "type": "duplicateAsImage",
        "isService": false
    },
    {
        "id": 5,
        "icon": "icon-Duplicate-as-page",
        "text": "Duplicate as page",
        "color": "#9C27B0",
        "type": "duplicateAsPage",
        "isService": false
    },
    {
        "id": 6,
        "icon": "icon-Enrich",
        "text": "Template",
        "color": "#009688",
        "type": "template",
        "isService": false
    },
    // {
    //     "id": 7,
    //     "icon": "icon-Mindmap",
    //     "text": "Mindmap",
    //     "color": "#F44336",
    //     "type": "mindmap",
    //     "isService": false
    // },
    {
        "id": 8,
        "icon": "icon-Youtube",
        "text": "Youtube",
        "color": "#F8908A",
        "type": "youtube",
        "isService": true
    },
    {
        "id": 9,
        "icon": "icon-Google-Calendar",
        "text": "Google calendar",
        "color": "#8B6F65",
        "type": "googleCalender",
        "isService": true
    },
    {
        "id": 10,
        "icon": "icon-Google-Maps",
        "text": "Google maps",
        "color": "#8B6F65",
        "type": "googleMaps",
        "isService": true
    },
    {
        "id": 11,
        "icon": "icon-Google-Docs",
        "text": "Google Docs",
        "color": "#1d7bf9",
        "type": "googleDocs",
        "isService": true
    },
    {
        "id": 12,
        "icon": "icon-Spread-Sheet",
        "text": "Google Sheets",
        "color": "#42a446",
        "type": "spreadSheet",
        "isService": true
    },
    {
        "id": 13,
        "icon": "icon-Presentation",
        "text": "Google Slides",
        "color": "#ffb90d",
        "type": "presentation",
        "isService": true
    }
    ]

    public static getTemplates() {
        this.TEMPLATES_Arr.forEach(template => {
            this.TEMPLATES[template.ID] = {
                "name": template.name,
                "ID": template.ID,
                "back_P": template.back_P,
                "backThumb": template.backThumb,
                "card": template.card,
                "front_P": template.front_P,
                "frontThumb": template.frontThumb,
                "page_P": template.page_P,
                "pageThumb": template.pageThumb
            };
        });
        return this.TEMPLATES;
    }
    public static getElectronTemplates() {
        this.Electron_TEMPLATES_Arr.forEach(template => {
            this.Electron_TEMPLATES[template.ID] = {
                "name": template.name,
                "ID": template.ID,
                "back_P": template.back_P,
                "backThumb": template.backThumb,
                "card": template.card,
                "front_P": template.front_P,
                "frontThumb": template.frontThumb,
                "page_P": template.page_P,
                "pageThumb": template.pageThumb
            };
        });
        return this.Electron_TEMPLATES;
    }
    public static getEnrichmentOptions() {
        this.ENRICHMENTOPIONS_arr.forEach(option => {
            this.ENRICHMENTOPIONS[option.type] = {
                "icon": option.icon,
                "id": option.id,
                "text": option.text,
                "color": option.color,
                "type": option.type,
                "isService": option.isService
            };
        });
        return this.ENRICHMENTOPIONS;


    }
    public static getBookTemplatesArr() {
        return this.TEMPLATES_Arr;
    }
    public static getElectronBookTemplatesArr() {
        return this.Electron_TEMPLATES_Arr;
    }
    public static getGUID() {
        //l0ts-n2sq-1525422797000-jbrh
        var timestamp = Math.floor(Date.now() / 1000);
        var guid = this.getRandomNumber() + '-' + this.getRandomNumber() + '-' + timestamp + '-' + this.getRandomNumber();
        return guid;

    }
    public static getRandomNumber() {
        var letters = '0123456789ABCDEF';
        var number = '0';
        for (var i = 0; i < 4; i++) {
            number += letters[Math.floor(Math.random() * 16)];
        }
        return number;
    }


}



// WEBPACK FOOTER //
// ./src/app/shared/models/constants.ts